<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["MEM"]["STIPM"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="/src/assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["IP"]}} :</span>
                                <CInput size="sm"
                                        :value="ip" @change="v => ip = v" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['MEM']['STIPM']}} </strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>
                                    {{this.getLanguage['GL']['ID']}}
                                    <i @click="setSortTable('I')" :class="setSortLogo('I')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')"></i>
                                </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['MEM']['CBL']}}
                                    <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')"></i>
                                </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['MEM']['TD']}}
                                    <i @click="setSortTable('TD')" :class="setSortLogo('TD')"></i>
                                </th>
                                <th>{{this.getLanguage['GL']['IP']}} </th>
                                <th>
                                    {{this.getLanguage['MEM']['LLTS']}}
                                    <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['RMK']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_MemberList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_MemberList">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class='kema-eft' @click="CheckingMember(data.AGI,data.I)">
                                <span class="grid-line">
                                    <div class="custom-tooltip">
                                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                        <span v-if="convertToBool(data.MT)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.MT}}</span>
                                    </div>
                                    <div class="float-right ml-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                        </svg>
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="isSENS == 1 && data.AGI != curAGI" class='kema-eft'>
                                <span class="grid-line">
                                    <div class="custom-tooltip">
                                        <span :style="getbgtooltip(data)">{{data.U}}</span>
                                        <span v-if="convertToBool(data.MT)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.MT}}</span>
                                    </div>
                                    <div class="float-right ml-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                        </svg>
                                    </div>
                                </span>
                            </td>
                            <td class="tableCtnRight">{{ formatNumber(data.TBL, 2, data.CS) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TD, 2, data.CS) }}</td>
                            <td>{{ data.TIP }}</td>
                            <td>{{ formatDateTime(data.LLTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.R }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { mapGetters } from 'vuex';
    import { loadingFullScreen } from '@/modules/Constant.js'
    import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            Loading
        },
        data() {
            return {
                int_RC: 200, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                ip: "",
                arr_MemberList: [],
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        created() {
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.ML';
            this.ip = this.$route.query.ip;
            this.getSameIPMemberList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        methods: {
            CheckingMember(agi,mi){ 
                let routeData = this.$router.resolve({ path:'/M/ML/CheckingMember', query:{ agi: agi, i: mi}});
                window.open(routeData.href, '_blank');
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            setSortTable(SV) {
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getSameIPMemberList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSameIPMemberList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getSameIPMemberList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            getSameIPMemberList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }
                path += "&f.IP=" + this.ip;

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/m/stip?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_MemberList = d.D.Items;
                        }
                    });
            }
        },
    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/Page/SameTransactionIP.vue